"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NODE_STATUS_DESC = exports.JOB_STATUS_DESC = exports.NODE_DEFAULT_SIZES = void 0;
/**
 * 节点的默认宽高，以设计稿为准
 */
exports.NODE_DEFAULT_SIZES = Object.freeze({
    width: 212,
    height: 54,
});
exports.JOB_STATUS_DESC = {
    pausing: '暂停中',
    paused: '已暂停',
    running: '运行中',
    suspended: '等待审批或回执',
    aborting: '正在阻断',
    aborted: '执行被阻断',
    completed: '完成',
    error: '执行失败',
};
exports.NODE_STATUS_DESC = {
    running: '运行中',
    aborted: '已取消',
    suspended: '等待审批或回执',
    completed: '运行完成',
    error: '失败',
    enter: '待运行',
    'failed-to-enter': '进入运行失败',
};
//# sourceMappingURL=consts.js.map